import React from 'react'
import editicon from '../../assets/images/edit-pencil-icon.svg'
import { useNavigate } from 'react-router-dom'


const SummaryShipMob = ({nodeData,edit}) => {
    const navigate = useNavigate()

    return (
        <div className="sm:block col-span-12 hidden">
            <div className="w-full rounded-2xl shadow-cardsection bg-white p-5">
                <div className="flex items-center gap-4">
                    <p className="flex text-secondary font-bold text-lg leading-5">Query Summary</p>
                </div>
                <div className="flex items-center gap-2 bg-bgbox p-5 mt-3 rounded-md justify-between">
                    <div className="flex flex-col gap-3">
                        <p className="text-secondary font-bold text-sm leading-4 w-full">{nodeData?.originShipment.originShipment} - {nodeData?.destinationShipment.destinationShipment}</p>
                        <ul className="flex items-center flex-wrap text-graytext font-normal text-xs leading-4 gap-3">
                            <li className='border-r-2 pr-2 border-gratext'>{nodeData?.cargoType}</li>
                            <li className='border-r-2 pr-2 border-gratext'>{nodeData?.containerLoad}</li>
                            <li className=''>{nodeData?.containerDetails.incoTerms}</li>
                        </ul>
                    </div>
                    {
                        edit &&
                        <div className="flex w-20 flex-wrap items-center justify-center" onClick={()=> navigate(-1)}>
                            <img src={editicon} alt="Edit" />
                            <span className='text-graytext font-normal text-xs leading-4'>Edit</span>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default SummaryShipMob